import {combineReducers, Action, Reducer} from 'redux'
import {PersistConfig} from 'redux-persist'
import {UserData} from 'types/commons'

export interface ReduxReducerState {
  user: UserData | null
}

export type ReduxStateKey = keyof ReduxReducerState

export interface ReduxReducerPersistConfig
  extends PersistConfig<ReduxReducerState> {
  whitelist?: ReduxStateKey[]
}

export type ReduxDispatchType = 'update' | 'reset'

export interface ReduxActionBase<K extends ReduxStateKey>
  extends Action<ReduxDispatchType> {
  key?: K
  payload?: Partial<ReduxReducerState[K]>
}

export type ReduxReducerMap = {
  [K in ReduxStateKey]: Reducer<ReduxReducerState[K], ReduxActionBase<K>>
}

function generateReducer<K extends ReduxStateKey>(
  key: K,
  initialState: ReduxReducerState[K],
): Reducer<ReduxReducerState[K], ReduxActionBase<K>> {
  return (state = initialState, action) => {
    if (action.key !== key) {
      return state
    }

    switch (action.type) {
      case 'update':
        return {...state, ...action.payload}
      case 'reset':
        return initialState
      default:
        return state
    }
  }
}

const mapReducer: ReduxReducerMap = {
  user: generateReducer('user', null),
}

export const REDUX_REDUCER = combineReducers(mapReducer)
